import { EVENT_VIEW_ITEM_LIST } from '~~/constants/googleTagManager';
import type { TagProduct } from '~~/types/integrations/tagManager/TagProduct';

export const buildViewItemListTags = ({
  id,
  name,
  itemsArray,
}: {
  id: string;
  name: string;
  itemsArray: TagProduct[]
}) => ({
  event: EVENT_VIEW_ITEM_LIST,
  item_list_id: id,
  item_list_name: name,
  ecommerce: { items: itemsArray },
});
